import { Box, CircularProgress, Typography } from '@material-ui/core';
import React from 'react';
export var Loading = function (_a) {
    var text = _a.text;
    return (React.createElement(Box, { height: '100%', display: 'flex', flexDirection: 'row', alignItems: 'center' },
        React.createElement(Box, { textAlign: 'center', width: '100%' },
            React.createElement(CircularProgress, null),
            ' ',
            React.createElement(Typography, { variant: 'h2', display: 'inline' }, text || 'Loading'))));
};
//# sourceMappingURL=loading.js.map